import { observer } from 'mobx-react'
import { Post } from '../../../../mocks/posts'
import { ReactComponent as Arrow } from '../../../../assets/news/arrow-up-right.svg'
import './index.scss'
import { getDateOut, getShortDate } from '../../../../hooks/dateOutputs'
import { useEffect, useState } from 'react'
import GlobalState from '../../../../stores/GlobalState'

const NewsPost = observer(({ dt, content }: { dt: Post; content: any }) => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
    })
  }, [])

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''

  return (
    <section className="news-post">
      <div className="news-post__col">
        <div className="news-post__topic">{dt.topic}</div>
      </div>
      <a className="news-post__img" href={`${lang}/news/${dt.id}`}>
        <img src={dt.img} />
      </a>
      <div className="news-post__info">
        <div className="news-post__info-top">
          <div
            className="news-post__info-title"
            onClick={() => {
              if (dt.websiteLink) {
                window.open(dt.websiteLink, '__blank')
              } else {
                window.location.href = `${lang}/news/${dt.id}`
              }
            }}
          >
            {dt.title}{' '}
            {dt.websiteLink && (
              <div className="news-post__link">
                <Arrow />
              </div>
            )}
          </div>
        </div>
        <div className="news-post__bottom">
          {width <= 900 && <div className="news-post__topic">{dt.topic}</div>}
          <div className="news-post__date">
            {getShortDate(
              new Date(dt.date).getTime(),
              content,
              GlobalState.currentLocale.lang,
            )}
          </div>
          {dt.websiteIcon && (
            <div className="news-post__logo">
              <img src={dt.websiteIcon} />
            </div>
          )}
        </div>
      </div>
    </section>
  )
})

export default NewsPost
